"use strict";
exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/Observer.js
// module id = 21
// module chunks = 0 1